import React from 'react';
import { ReactComponent as SiteIcon } from './site_icon.svg';

export default props => {
    const { className } = props;
    return <SiteIcon className={className} aria-label='Site Icon'/>
}